import { Access } from '@finam/txservices-edox/access/proto';
import { ProtoUtils } from '@finam/txservices-auth';

var buildPersonalData = function buildPersonalData(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      middleName = _ref.middleName,
      birthDate = _ref.birthDate,
      gender = _ref.gender;

  if (!firstName && !lastName && !middleName && !birthDate && !gender) {
    return undefined;
  }

  return Access.PersonalData.create({
    firstName: firstName,
    lastName: lastName,
    middleName: middleName,
    dateOfBirth: birthDate ? ProtoUtils.dateToProtoDate(birthDate) : undefined,
    gender: gender
  });
};

export default buildPersonalData;